const IMG_URL = "./img/icons/"

export const SHARE = {alt: "transfer", src: `${IMG_URL}share.png`}

export const PORCENTAGE = {alt: "transfer", src: `${IMG_URL}porcentage.png`}

export const GIFT = {alt: "transfer", src: `${IMG_URL}gift.png`}

export const COINS = {alt: "transfer", src: `${IMG_URL}coins.png`}

export const COIN = {alt: "transfer", src: `${IMG_URL}coin.png`}

export const MORE = {alt: "transfer", src: `${IMG_URL}more-coin.png`}

export const EDIT = {alt: "transfer", src: `${IMG_URL}edit.png`}

export const CROWN = {alt: "transfer", src: `${IMG_URL}crown.png`}

export const FRIENDS = {alt: "transfer", src: `${IMG_URL}friends.png`}

export const PROFILE = {alt: "transfer", src: `${IMG_URL}profile.png`}

